import { getCommonClientConfig } from "@/api";


/**
 * 判断是否安装app
 * @url ios,android 提供（打开app的链接）
 * @callback （未安装app的回调）
 * */
function openApp(callback) {
    let { isAndroid, isIOS, isIOS9 } = judgeClient();

    const url = isAndroid ? "yoclawyer://yoclawyer/open" + window.location.search : "Lawyer://" + window.location.search;

    if (isWeiXin()) {
        alert("请您在浏览器中打开,即可下载");
        return;
    }

    if (isAndroid || isIOS) {
        let hasApp = true, t = 1000,
            t1 = Date.now(),
            ifr = document.createElement("iframe");
        setTimeout(function () {
            if (!hasApp) {
                callback && callback();
            }
            document.body.removeChild(ifr);
        }, 2000);

        ifr.setAttribute("src", url);
        ifr.setAttribute("style", "display:none");
        document.body.appendChild(ifr);

        setTimeout(function () { // 启动app时间较长处理
            let t2 = Date.now();
            if (t2 - t1 < t + 100) {
                hasApp = false;
            }
        }, t);
    }

    if (isIOS9) {
        location.href = url;
        setTimeout(function () {
            callback && callback();
        }, 250);
        setTimeout(function () {
            location.reload();
        }, 1000);
    }
}

/** 按钮点击下载 */
export function buttonDownload() {
    const { isIOS } = judgeClient();

    getApk().then((value) => {
        if (isIOS) {
            window.location.href = value.downloadGfUrlIos;
        } else {
            // 先喚醒安卓应用市场
            window.location.href = value.androidGfAppstoreUrl;
            // 防止安卓没有上架到应用市场
            setTimeout(function () {
                window.location.href = value.downloadGfUrlApk;
            }, 500);
        }
    }).catch((err) => {
        console.log(err);
    });
}

/** 先判断有没有app，如果没有则下载 */
export function awakeApp() {
    openApp(buttonDownload);
}


/** 判断是否ios */
export function isIOSClient() {
    return judgeClient().isIOS;
}


/** 获取操作系统 */
export function judgeClient() {

    let isAndroid = false, isIOS = false, isIOS9 = false, version, u = navigator.userAgent, ua = u.toLowerCase();

    // Android系统
    if (u.indexOf("Android") > -1 || u.indexOf("Linux") > -1) {   // android终端或者uc浏览器
        isAndroid = true;
    }
    // ios
    if (ua.indexOf("like mac os x") > 0) {
        let regStr_saf = /os [\d._]*/gi;
        let verinfo = ua.match(regStr_saf);
        version = (verinfo + "").replace(/[^0-9|_.]/ig, "").replace(/_/ig, ".");
    }
    let version_str = version + "";
    // ios9以上
    if (version_str !== "undefined" && version_str.length > 0) {
        version = parseInt(version);
        if (version >= 8) {
            isIOS9 = true;
        } else {
            isIOS = true;
        }
    }


    return { isAndroid, isIOS, isIOS9 };
}


/** 判断是否安卓 */
export function isAndroidClient() {
    return judgeClient().isAndroid;
}

/** 获取下载地址 */
export function getApk() {
    return getCommonClientConfig().then((value) => {
        return value.data;
    });
}

/** 判断是否微信 */
export function isWeiXin() {
    return /micromessenger/i.test(navigator.userAgent.toLowerCase()) || typeof navigator.wxuserAgent !== "undefined";
}

